// Previously registered an empty service worker so Chrome would treat the app
// as a PWA. That is no longer required (Chrome 108+ / 112+), and the empty
// fetch handler caused unhandled rejections in Bugsnag.
// Unregister so clients that still have the old worker installed drop it.

export function unregister() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker.getRegistrations()
    .then(registrations =>
      Promise.all(registrations.map(registration => registration.unregister()))
    )
    .catch(() => {
      // Best-effort cleanup; the service worker is not required.
    });
}
